import { z } from "zod";

const MAX_FILE_SIZE = 1024 * 1024 * 10;
const ACCEPTED_IMAGE_MIME_TYPES = ["image/jpeg", "image/jpg", "image/png", "image/gif", "image/webp"];

export const schema = z.object({
  designation: z.string().nonempty("Ce champs est obligatoire."),
});

export const Couponschema = z
  .object({
    percent: z.number().min(1, "l nombre doit étre supérieur à 0 ").nonnegative("Ce champ est obligatoire."),
    max_redemptions: z.boolean({ required_error: "Ce champs est obligatoire." }),
    number_of_redemptions: z
      .number()
      .min(0, "le nombre doit être supérieur à 0")
      .nonnegative("Ce champ est obligatoire.")
      .optional(),
  })
  .refine(
    (data) => {
      return (
        data.max_redemptions === false ||
        (data.max_redemptions === true && data.number_of_redemptions !== undefined)
      );
    },
    {
      message: "number_of_redemptions est obligatoire lorsque max_redemptions est faux.",
      path: ["number_of_redemptions"],
    }
  );

export const announceCategorySchema = z.object({
  designation: z.string().nonempty("Ce champs est obligatoire."),
  images: z
    .instanceof(File, {
      message: "L'image  est obligatoire",
    })
    .refine(
      (file) => !file || (file.size <= MAX_FILE_SIZE && ACCEPTED_IMAGE_MIME_TYPES.includes(file.type)),
      "Le fichier doit être une image au format JPEG, PNG , GIF "
    ),
});

export const creatorSchema = z.object({
  login: z.string().min(1, { message: "Pseudo est obligatoire." }),
  email: z.string().email({ message: "Veuillez entrer une adresse email valide." }),

  password: z
    .string()
    .regex(
      /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?À-ÿ]).{8,26}$/,
      "Le mot de passe doit contenir au moins 1 lettre minuscule, 1 lettre majuscule, 1 chiffre et 1 caractère spécial."
    ),
});

export type CouponDataSchemaType = z.infer<typeof Couponschema>;
export type CreatorSchemaType = z.infer<typeof creatorSchema>;

export type DataSchemaType = z.infer<typeof schema>;
export type AnnounceCategoryDataSchemaType = z.infer<typeof announceCategorySchema>;

export const videoDemoSchema = z.object({
  title: z.string().min(1, "Le titre est requis").max(255, "Le titre ne peut pas dépasser 255 caractères"),
  url: z
    .instanceof(File)
    .optional()
    .refine(
      (file) => !file || ["video/mp4", "video/mov", "video/avi"].includes(file.type),
      "Le fichier doit être une vidéo (mp4, mov, avi)"
    )
    .refine((file) => !file || file.size <= 100 * 1024 * 1024, "Le fichier ne doit pas dépasser 100 Mo"),
});

export type VideoDemoSchemaType = z.infer<typeof videoDemoSchema>;
